import { PURPOSE_SOURCE_VALUES } from '@sravni/creditselection-customer-utils/lib/utils/customers';

import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';
import type { TCreditPurpose } from 'constants/dictionaries';

import type { TSelectedProductType } from 'shared/types/TCustomerService';

import type { TProductTypeTabId } from './productTypeTab.types';

export type TProductTypeTabPayload = {
  id: TProductTypeTabId;
  selectedProductType: TSelectedProductType;
  purpose: TCreditPurpose;
};

export const PRODUCT_TYPE_TAB_PAYLOADS: TProductTypeTabPayload[] = [
  {
    id: 'cash',
    selectedProductType: PRODUCT_TYPES_VALUES.CREDIT,
    purpose: PURPOSE_SOURCE_VALUES.MONEY,
  },
  {
    id: 'creditCard',
    selectedProductType: PRODUCT_TYPES_VALUES.CREDIT_CARD,
    purpose: PURPOSE_SOURCE_VALUES.MONEY,
  },
  {
    id: 'microCredit',
    selectedProductType: PRODUCT_TYPES_VALUES.MICRO_CREDIT,
    purpose: PURPOSE_SOURCE_VALUES.MONEY,
  },
  {
    id: 'refinance',
    selectedProductType: PRODUCT_TYPES_VALUES.CREDIT,
    purpose: PURPOSE_SOURCE_VALUES.REFINANCE_CREDIT,
  },
];
